<template>
  <div id="footer" class="container-fluid ">
    <p class="address_tel_fax">
      <span>地址：成都市金牛区福堤路99号数媒大厦1210号</span>
      <span>Tel：18108049271 </span>
      <span>邮箱：875179148@qq.com</span>
    </p>
    <div class="flex row">
      <div class="mb-20">
        <p>联系BOSS</p>
        <img class="wechat" src="@/assets/img/wechat_code1.jpg" alt="">
      </div>
      <div>
        <p class="txt">联系商务</p>
        <div class="flex">
          <img class="wechat mb-20" src="@/assets/img/wechat_code4.jpg" alt="">
          <img class="wechat mb-20" src="@/assets/img/wechat_code2.jpg" alt="">
          <img class="wechat mb-20" src="@/assets/img/wechat_code3.jpg" alt="">
        </div>
      </div>
    </div>

    <p class="copy">Copyright &copy; 2018 - {{ new Date().getFullYear() }} 四川杰锐易联信息技术有限公司</p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
  padding-top: 20px;
}
.mb-20{
  margin-bottom: 20px;
}
.txt {
  text-align: left;
  padding-left: 24px;
}

.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}

.title {
  font-size: 25px;
  margin-bottom: 20px;
}

.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}

.flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.email_wx {
  color: #d3d3d3;
  font-size: 14px;
  margin-left: 10px
}

.wechat {
  width: 150px;
  height: 200px;
  margin-left: 10px
}

.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin:  10px;
}

/* 媒体查询（手机） */
@media screen and (max-width: 768px){

  .flex{
    flex-direction: column;
  }
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }

  .address_tel_fax {
    font-size: 12px;
  }

  .email_wx {

    font-size: 12px;
  }

  .copy {
    font-size: 12px;
    margin:  10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue